import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShareOs: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"share-os, export, upload"} maskId="square-filled-radius-0-stroke-1-IconShareOs"><path d="M11.9999 0.792969L17.2071 6.00007L16.5 6.70718L12.5 2.70728V14.0001H11.5V2.70708L7.50001 6.70718L6.79289 6.00009L11.9999 0.792969Z" fill="currentColor"/><path d="M4 9.00008H10.5V15.0001H13.5V9.00008H20V21.0001H4V9.00008Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconShareOs;
